import React from "react";
import DefaultButton from '../../../components/DefaultButton'

export default function PhysicalBanner({ data }) {
  return (
    <>
      <section className="physical-banner-area header-gap">
        <img src={data?.img} alt="Physical Banner Image" />
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h1 className="heading">{data?.head}</h1>
              <DefaultButton to={data?.slug} text={data?.btn} color />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}